class CreateAiProvider {
	constructor(
		public readonly accountId: number,
		public readonly label: string,
		public readonly kind: string,
		public readonly baseUrl: string,
		public readonly apiVersion: string | null,
		public readonly apiKey: string,
		public readonly isPlatformCredential: boolean,
	) {
		Object.freeze(this);
	}

	// `accountId` is the route identifier: it must never be echoed in the request body.
	toJSON(): Record<string, unknown> {
		return {
			label: this.label,
			kind: this.kind,
			baseUrl: this.baseUrl,
			apiVersion: this.apiVersion,
			apiKey: this.apiKey,
			isPlatformCredential: this.isPlatformCredential,
		};
	}
}

export default CreateAiProvider;
